export default {
    title: "Poznámky",
    text_0: "List",
    text_1: "Úprava poznámky",
    text_2: "Tvorba poznámky",
    text_3: "Dátum",
    text_4: "Poznámka",
    text_5: "Uložiť",
    text_6: "Ukončiť",
    text_alert_1: "Poznámka bola odstránena.",
    text_alert_2: "Poznámka bola vytvorená",
    text_alert_3: "Poznámka bola upravená",
};
